'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { isAppBridge } from '@/app/helpers/appStorageMethod';

/**
 * Listen for universal link events from native app via AppBridge
 * Native app intercepts universal links and sends them via postMessage
 *
 * Example event:
 * window.dispatchEvent(new CustomEvent('universalLink', {
 *   detail: { normalizedUrl: 'https://stage.joysamconnect.com/events/roulette/latest' }
 * }));
 */
export default function UniversalLinkListener() {
    const router = useRouter();

    useEffect(() => {
        // Only run in app environment
        if (!isAppBridge()) return;

        const handleUniversalLink = (event: any) => {
            try {
                const normalizedUrl = event.detail?.normalizedUrl;

                if (!normalizedUrl) {
                    console.warn('[UniversalLink] No normalizedUrl provided in event detail');
                    return;
                }

                // Parse URL and extract pathname
                const url = new URL(normalizedUrl);
                // 쿼리까지 살린다. 마이룸 소셜 연결 결과처럼 값이 쿼리로 오는 딥링크가 있어,
                // pathname 만 쓰면 그 값이 조용히 사라진다(예: /myroom?linked=ok).
                const path = url.pathname + url.search; // e.g. "/events/roulette/latest"

                console.log('[UniversalLink] Received universal link:', normalizedUrl);
                console.log('[UniversalLink] Navigating to:', path);

                // Navigate to the path
                router.push(path);

            } catch (error) {
                console.error('[UniversalLink] Error handling universal link:', error);
                console.error('[UniversalLink] Event detail:', event.detail);
            }
        };

        // Add event listener
        window.addEventListener('universalLink', handleUniversalLink as EventListener);

        console.log('[UniversalLink] Listener registered');

        // Cleanup
        return () => {
            window.removeEventListener('universalLink', handleUniversalLink as EventListener);
            console.log('[UniversalLink] Listener removed');
        };
    }, [router]); // Re-create listener when router changes

    // This component doesn't render anything
    return null;
}
